'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryDisplay = exports.dimensionValueDisplayAt = exports.dimensionValueDisplay = undefined;

var _reduce2 = require('lodash/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _has2 = require('lodash/has');

var _has3 = _interopRequireDefault(_has2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _isNil2 = require('lodash/isNil');

var _isNil3 = _interopRequireDefault(_isNil2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dimensionValueDisplay = exports.dimensionValueDisplay = function dimensionValueDisplay(display) {
  var accessors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dimensionValue) {
    var id = (0, _get3.default)(dimensionValue, accessors.id || 'id', '');
    var name = (0, _get3.default)(dimensionValue, accessors.name || 'name', '');
    // a non-coded component (dim | attr) has no name, names nor label
    // the only valid thing to display is the id
    if ((0, _get3.default)(dimensionValue, 'isNonCoded', false)) return id;
    //auto-generated flags have no id nor name
    if ((0, _isEmpty3.default)(id) && (0, _isEmpty3.default)(name)) return '';
    switch (display) {
      case 'label':
        return (0, _isEmpty3.default)(name) ? '[' + id + ']' : name;
      case 'code':
        return id;
      case 'both':
        if ((0, _isNil3.default)(id) || (0, _isEmpty3.default)(id)) return name;
        return '(' + id + ') ' + name;
      default:
        return null;
    }
  };
};

var dimensionValueDisplayAt = exports.dimensionValueDisplayAt = function dimensionValueDisplayAt(dimension, index, display) {
  var dimensionValue = (0, _get3.default)(dimension, 'values[' + Number(index) + ']', {});
  return dimensionValueDisplay(display)(dimensionValue);
};

var categoryDisplay = exports.categoryDisplay = function categoryDisplay(splitObservationKey, dimensions, dimensionsWithValuesIndexedById, rejectedId, display) {
  return (0, _reduce3.default)(splitObservationKey, function (memo, dimensionValueIndex, dimensionIndex) {
    var dimension = (0, _get3.default)(dimensions, '[' + dimensionIndex + ']', {});
    if ((0, _has3.default)(dimensionsWithValuesIndexedById, dimension.id) && dimension.id !== rejectedId) {
      memo.push(dimensionValueDisplayAt(dimension, dimensionValueIndex, display));
    }
    return memo;
  }, []).join(' - ');
};